export default __webpack_public_path__ + "static/media/yogurt2.efd1d250.jpg";